<app-new-player *ngIf="newPlayer" [game]="game"></app-new-player>
<div id="game-play-container">
  <div [ngClass]="{'trivia-data-container': game.kind == 'trivia', 'match-data-container': game.kind == 'match'}">
    <img class="main-img" id="cardiogram" src="./assets/images/icons/cardiogram.png">
    <div id="lifes-container">
      <div class="life" *ngFor="let life of lifesArray;let i = index">
        <img src="./assets/images/icons/heart2.png" id="heart{{i}}"
          class="life">
        <img src="./assets/images/icons/heart3.png"
          class="life empty-life">
      </div>
    </div>
  </div>
  <div
    [ngClass]="{'trivia-large-data-container': game.kind == 'trivia', 'match-large-data-container': game.kind == 'match'}">
    <img id="timer-icon" src="./assets/images/icons/stopwatch.png">
    <div>
      <app-timer></app-timer>
    </div>
  </div>
  <div [ngClass]="{'trivia-data-container': game.kind == 'trivia', 'match-data-container': game.kind == 'match'}">
    <img class="main-img" src="./assets/images/icons/money.png">
    <div id="score-scale">
      <h1 id="score">{{score}}</h1>
    </div>
  </div>
  <img id="combo-img" class="combo-img" [attr.src]="'../../assets/images/icons/combo' + gamePlayService.combo + '.png'">
</div>